import defaults from 'lodash/defaults';
import {
  USER_SIGN_IN,
  USER_SIGN_OUT,
  FETCHING_SITE,
  FETCH_SITE_SUCCESS,
  FETCH_SITE_FAILURE,
  RECEIVE_ANSWERS,
  RECEIVE_USERS,
  UPDATE_USER_TABLE_FILTERS,
  RECEIVE_USER,
  RECEIVE_ADMINS,
  USER_ONLINE,
  USER_OFFLINE,
} from '../constants';

const initialState = {
  loggedIn: false,
  checkedAuth: false,
  userUID: null,
  email: null,
  posts: {},
  fetchingSite: false,
  fetchSiteError: false,
  fetchedUsers: false,
  fetchedAnswers: false,
  fetchedSite: false,
  users: {},
  answers: {},
  userTableFilters: {
    search: '',
    city: '',
    group: '',
    eventDay: '',
  },
  receivedAdmins: false,
  admins: [],
  lastOnline: 0,
  lastOffline: 0,
};

function appReducer(state = initialState, action) {
  switch (action.type) {
    case USER_ONLINE:
      return {
        ...state,
        lastOnline: action.payload.timestamp,
      };
    case USER_OFFLINE:
      return {
        ...state,
        lastOffline: action.payload.timestamp,
      };
    case USER_SIGN_IN:
      return Object.assign({}, state, {
        loggedIn: true,
        email: action.payload.email,
        userUID: action.payload.uid,
        checkedAuth: true,
      });

    case USER_SIGN_OUT:
      return Object.assign({}, state, {
        loggedIn: false,
        userUID: null,
        checkedAuth: true,
      });

    case FETCHING_SITE:
      return Object.assign({}, state, {
        fetchingSite: true,
        fetchSiteError: false,
        fetchedSite: false,
      });

    case FETCH_SITE_FAILURE:
      return Object.assign({}, state, {
        fetchedSite: false,
        fetchingSite: false,
        fetchSiteError: true,
      });

    case FETCH_SITE_SUCCESS:
      return Object.assign({}, state, {
        posts: action.payload.siteData.posts || {},
        fetchedSite: true,
        fetchingSite: false,
        fetchSiteError: false,
      });

    case RECEIVE_ANSWERS:
      return {
        ...state,
        answers: {
          ...state.answers,
          ...action.payload.answers,
        },
        fetchedAnswers: true,
      };

    case RECEIVE_USERS:
      return {
        ...state,
        ...{
          users: action.payload.users,
          fetchedUsers: true,
        },
      };

    case RECEIVE_ADMINS:
      return {
        ...state,
        receivedAdmins: true,
        admins: action.payload.admins
      };

    case RECEIVE_USER:
      return {
        ...state,
        ...{
          users: {
            ...state.users,
            [action.payload.userUID]: action.payload.userData
          },
        }
      }

    case UPDATE_USER_TABLE_FILTERS:
      return {
        ...state,
        ...{
          userTableFilters: defaults(action.payload.filters, {
            search: '',
            city: '',
            eventDay: '',
            group: '',
          }),
        },
      };

    default:
      return state;
  }
}

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js